import classNames from "classnames";
import dompurify from "isomorphic-dompurify";

import { Tooltip } from "@jti/ui/components/Tooltip";

import styles from "./ProductPromoOffer.module.scss";

type ProductPromoOfferProps = {
  title: string;
  description?: string;
  hint?: string;
  alertBox?: boolean;
};

const { sanitize } = dompurify;

export const ProductPromoOffer = ({ title, description = "", hint = "", alertBox = false }: ProductPromoOfferProps) => {
  return (
    <section className={classNames(styles.productPromoContainer, { [styles.productPromoAlertBox]: alertBox })}>
      <div className={styles.header}>
        <h3 className={styles.title}>{title}</h3>
        {hint && <Tooltip content={<span>{hint}</span>} size="small" dataTestId="productPromo-popover" withCloseIcon />}
      </div>
      {description && (
        <div
          className={styles.body}
          dangerouslySetInnerHTML={{
            __html: sanitize(description),
          }}
        />
      )}
    </section>
  );
};

export default ProductPromoOffer;
